/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailContactViewModel
 */
export interface EmailContactViewModel {
    /**
     * 
     * @type {string}
     * @memberof EmailContactViewModel
     */
    emailAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof EmailContactViewModel
     */
    partyEmailContactId?: number;
    /**
     * 
     * @type {number}
     * @memberof EmailContactViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EmailContactViewModel
     */
    isPreferredEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmailContactViewModel
     */
    isSignatoryEmail?: boolean;
}

/**
 * Check if a given object implements the EmailContactViewModel interface.
 */
export function instanceOfEmailContactViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailContactViewModelFromJSON(json: any): EmailContactViewModel {
    return EmailContactViewModelFromJSONTyped(json, false);
}

export function EmailContactViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailContactViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailAddress': !exists(json, 'EmailAddress') ? undefined : json['EmailAddress'],
        'partyEmailContactId': !exists(json, 'PartyEmailContactId') ? undefined : json['PartyEmailContactId'],
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'isPreferredEmail': !exists(json, 'IsPreferredEmail') ? undefined : json['IsPreferredEmail'],
        'isSignatoryEmail': !exists(json, 'IsSignatoryEmail') ? undefined : json['IsSignatoryEmail'],
    };
}

export function EmailContactViewModelToJSON(value?: EmailContactViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EmailAddress': value.emailAddress,
        'PartyEmailContactId': value.partyEmailContactId,
        'PartyId': value.partyId,
        'IsPreferredEmail': value.isPreferredEmail,
        'IsSignatoryEmail': value.isSignatoryEmail,
    };
}

